import { render } from "./loadingspinnerComponent.vue?vue&type=template&id=f65e8474"
import script from "./loadingspinnerComponent.vue?vue&type=script&lang=js"
export * from "./loadingspinnerComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__